import { Quantity } from '@elderbyte/ngx-starter'
import { ItemUnitBundle } from '../package'

export enum ItemUnitBundleOperation {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  CLEAR = 'CLEAR',
}

/**
 * @param bundleId null in case of create
 */
export interface Bundle {
  bundleId?: string
  itemId: string
  quantity: Quantity
}

export interface ItemUnitBundleCommand {
  workBatchId: string
  operation: ItemUnitBundleOperation
  bundles: Bundle[]
}

export const addCommand = (
  workBatchId: string,
  toAdd: [itemId: string, quantity: Quantity][]
): ItemUnitBundleCommand => ({
  workBatchId,
  bundles: toAdd.map(([itemId, quantity]) => ({ itemId, quantity })),
  operation: ItemUnitBundleOperation.ADD,
})

export const removeCommand = (
  workBatchId: string,
  bundles: ItemUnitBundle[]
): ItemUnitBundleCommand => fromPkgBundles(workBatchId, bundles, ItemUnitBundleOperation.REMOVE)

export const clearCommand = (
  workBatchId: string,
  bundles: ItemUnitBundle[]
): ItemUnitBundleCommand => fromPkgBundles(workBatchId, bundles, ItemUnitBundleOperation.CLEAR)

const fromPkgBundles = (
  workBatchId: string,
  bundles: ItemUnitBundle[],
  operation: ItemUnitBundleOperation
): ItemUnitBundleCommand => ({
  workBatchId,
  operation,
  bundles: bundles.map((pkgBundle) => toCmdBundle(pkgBundle)),
})

const toCmdBundle = (pkgBundle: ItemUnitBundle): Bundle => ({
  bundleId: pkgBundle.id,
  itemId: pkgBundle.itemId,
  quantity: pkgBundle.packagedQuantity,
})
